(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["studio-collection"]) return;
  try {
    

  if (!customElements.get('studio-collection')) {
    customElements.define('studio-collection', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.classList.add('sc--ready');
        this.media = matchMedia('(max-width: 989px)');
        this.mobileChange = () => { this.querySelector('[data-sc-filters]').open = !this.media.matches; };
        this.mobileChange();
        this.media.addEventListener('change', this.mobileChange);
        this.addEventListener('click', event => {
          const link = event.target.closest('.adg-tagf a, [data-sc-pagination] a[rel], [data-sc-reset]');
          if (!link || event.button !== 0 || event.ctrlKey || event.metaKey || event.altKey || event.shiftKey) return;
          const url = new URL(link.href);
          if (url.origin !== location.origin) return;
          event.preventDefault();
          if (link.closest('.adg-tagf') || link.hasAttribute('data-sc-reset')) {
            url.searchParams.delete('page');
            const sort = this.querySelector('[name="sort_by"]').value;
            if (sort) url.searchParams.set('sort_by', sort);
          }
          this.navigate(url, true);
        });
        this.addEventListener('submit', event => {
          if (!event.target.matches('[data-sc-sort]')) return;
          event.preventDefault();
          this.sort();
        });
        this.addEventListener('change', event => {
          if (event.target.matches('[name="sort_by"]')) this.sort();
        });
        this.back = () => this.navigate(new URL(location.href), false);
        window.addEventListener('popstate', this.back);
      }
      disconnectedCallback() {
        this.controller?.abort();
        window.removeEventListener('popstate', this.back);
        this.media?.removeEventListener('change', this.mobileChange);
        this.initialized = false;
      }
      sort() {
        const url = new URL(location.href);
        url.searchParams.set('sort_by', this.querySelector('[name="sort_by"]').value);
        url.searchParams.delete('page');
        this.navigate(url, true);
      }
      async navigate(url, push) {
        this.controller?.abort();
        const controller = this.controller = new AbortController();
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        const request = new URL(url);
        request.searchParams.set('section_id', this.dataset.sectionId);
        const expanded = [...this.querySelectorAll('.adg-tagf details[open]')].map(item => item.querySelector('summary')?.textContent.trim());
        this.setAttribute('aria-busy', 'true');
        this.querySelector('[data-sc-status]').textContent = this.dataset.loading;
        try {
          const response = await fetch(request, {signal: controller.signal});
          if (!response.ok) throw new Error('Collection unavailable');
          const documentCopy = new DOMParser().parseFromString(await response.text(), 'text/html');
          const fresh = documentCopy.querySelector('studio-collection');
          if (!fresh || fresh.dataset.sectionId !== this.dataset.sectionId) throw new Error('Collection missing');
          if (controller.signal.aborted) return;
          this.innerHTML = fresh.innerHTML;
          this.querySelector('[data-sc-filters]').open = !this.media.matches;
          this.querySelectorAll('.adg-tagf details').forEach(item => {
            if (expanded.includes(item.querySelector('summary')?.textContent.trim())) item.open = true;
          });
          if (push) history.pushState({studioCollection: true}, '', url);
          const count = this.querySelector('[data-sc-count]');
          this.querySelector('[data-sc-status]').textContent = count.textContent;
          const results = this.querySelector('.sc-toolbar');
          results.focus({preventScroll: true});
          if (results.getBoundingClientRect().top < 0) results.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
        } catch (error) {
          if (error.name !== 'AbortError') location.assign(url.href);
        } finally {
          if (this.controller === controller) this.removeAttribute('aria-busy');
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
